const name = "STAKES";

export const FETCH_STAKES = `${name}/FETCH_STAKES`;
export const FETCH_STAKES_START = `${FETCH_STAKES}/START`;
export const FETCH_STAKES_END = `${FETCH_STAKES}/END`;
export const FETCH_STAKES_FAILURE = `${FETCH_STAKES}/FAILURE`;
export const FETCH_STAKES_SUCCESS = `${FETCH_STAKES}/SUCCESS`;

export const RESET = `${name}/RESET`;
